import React, { Dispatch, SetStateAction } from 'react'
import { CldUploadWidget, CloudinaryUploadWidgetResults } from 'next-cloudinary'
import { Button } from '@/atoms/Button'

interface CloudinaryUploadWidgetProps {
  getImage: Dispatch<SetStateAction<string>>
  btnText?: string
}

export const CloudinaryUploadWidget: React.FC<CloudinaryUploadWidgetProps> = ({
  getImage,
  btnText = 'Create Social Frame',
}) => {
  const presets = ['jpeg, jpg, png']
  const getMyUploadPresets = (cb: (presets: string[]) => void) => cb(presets)

  const handleOnUpload = (result: CloudinaryUploadWidgetResults) => {
    if (typeof result.info === 'object' && result.info?.path) {
      getImage(result.info.path)
    }
  }

  return (
    <CldUploadWidget
      uploadPreset="social-profile"
      options={{
        sources: ['local', 'camera'],
        getUploadPresets: getMyUploadPresets,
      }}
      onSuccess={handleOnUpload}
    >
      {({ open }) => {
        const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          open()
        }

        return (
          <Button variant="white" className="my-2 rounded-lg py-3 lg:m-0" onClick={handleOnClick}>
            {btnText}
          </Button>
        )
      }}
    </CldUploadWidget>
  )
}
